<div class="product-feature-investment">
  <ng-container>
    <mfp-switch
      [name]="product.id + '-' + investment.id"
      [disabled]="disabled"
      [ngModel]="investment.active"
      (ngModelChange)="onChangeActive($event)"
    ></mfp-switch>
  </ng-container>
  <ng-template #fixed>
    <div class="product-feature__icon">
      <ng-template>
        <img mfpLazyImage lazySrc="assets/icons/tick.svg" />
      </ng-template>
    </div>
  </ng-template>
  <div class="product-feature-investment__content">
    <p class="product-feature-investment__text">{{ investment.description }}</p>
    <div class="product-feature-investment__input">
      <div class="product-feature-investment__select">
        <mfp-select
          view="agent"
          name="select"
          [disabled]="!investment.active || disabled"
          [error]="investment.active! && !disabled && getSelectError() != ''"
          [helper]="investment.active! && !disabled ? getSelectError() : ''"
          [placeholder]="selectPlaceholder ? selectPlaceholder : ''"
          [required]="false"
          [readonly]="false"
          [success]="false"
          [options]="values"
          [ngModel]="getSelectValue()"
          (ngModelChange)="onChangeSelect($event)"
        ></mfp-select>
      </div>
      <mfp-input
        view="agent"
        name="input"
        [type]="'number'"
        [placeholder]="selectPlaceholder || ''"
        [required]="false"
        [readonly]="false"
        [disabled]="!investment.active || disabled"
        [success]="false"
        [error]="investment.active! && !disabled && getAmountError() != ''"
        [helper]="investment.active! && !disabled ? getAmountError() : ''"
        [ngModel]="getValue()"
        (ngModelChange)="onChangeAmount($event)"
      ></mfp-input>
    </div>
  </div>
</div>
